import {
    Component,
    OnDestroy,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TextareaComponent } from "@components/textarea/textarea.component";
import { TextmultilineComponent } from "@components/textmultiline/textmultiline.component";
import { Subscription } from "rxjs";
import { UpdateAtgardAnteckningProdplanCommand } from "~app/features/planera/commands/UpdateAtgardAnteckningProdsplanCommand";
import { ArbetsorderDisabledFlag } from "~app/features/planera/model/ArbetsorderDisabledFlag";
import { IArbetsorderDetail } from "~app/features/planera/model/IArbetsorderDetail";
import { IAtgard } from "~app/features/planera/model/IAtgard";
import { ArbetsorderInfoAnteckningSelection } from "../arbetsorder-info-anteckningar.model";
import { ArbetsorderInfoAnteckningarService } from "../arbetsorder-info-anteckningar.service";

@Component({
    selector: "rask-arbetsorder-info-atgard-anteckningar",
    templateUrl: "./arbetsorder-info-atgard-anteckningar.component.html",
    styleUrls: ["./arbetsorder-info-atgard-anteckningar.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TextareaComponent,
        FormsModule,
        TextmultilineComponent
    ]
})
export class ArbetsorderInfoAtgardAnteckningarComponent implements OnInit, OnDestroy {
    arbetsorder: IArbetsorderDetail;
    selectedAtgard: IAtgard;

    private readonly arbetsorderInfoAnteckningarService = inject(ArbetsorderInfoAnteckningarService);

    private selectionSubscription: Subscription;

    isDetailEditable = () => this.arbetsorder.isEditableForMode(ArbetsorderDisabledFlag.makulerad);

    ngOnDestroy(): void {
        this.selectionSubscription.unsubscribe();
    }

    ngOnInit(): void {
        this.selectionSubscription = this.arbetsorderInfoAnteckningarService.selectionChanged.subscribe((obj: ArbetsorderInfoAnteckningSelection) => {
            this.arbetsorder = obj.arbetsorder;
            this.selectedAtgard = obj.atgard;
        });
    }

    updateAtgAnteckningProduktionsplanering = () => {
        this.arbetsorder.commandManager.addOrUpdate(new UpdateAtgardAnteckningProdplanCommand(c => {
            c.atgardGuid = this.selectedAtgard.guid;
            c.anteckning = this.selectedAtgard.anteckningProduktionsplanering;
        }), command => command.atgardGuid === this.selectedAtgard.guid);
    };
}
